import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'assets/icons/Loading';

const Spinner = ({ className, noBackdrop }) => {
  return (
    <div className={className}>
      <div className="spinner">
        <Loading />
      </div>
      {!noBackdrop && <div className="spinner__backdrop"></div>}
    </div>
  );
};

Spinner.defaultProps = {
  noBackdrop: false
};

Spinner.propTypes = {
  className: PropTypes.string,
  noBackdrop: PropTypes.bool
};

export default Spinner;
